export default __webpack_public_path__ + "static/media/swisslog.0139dce0.png";